module.exports = __webpack_public_path__ + "img/flow-tips.fa1797a4.png";